import OfferList from '@/components/offer/OfferList'

const OffersPage = () => {
  return <OfferList />
}

export default OffersPage
